<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="min-h-screen">
    <div class="page-content--header">
      <slot name="header" />
    </div>
    <IoAlerts class="io-alert" />
    <IoSectionTop
      :headline="title"
      :center="center"
    >
      <template
        v-if="description"
        #default
      >
        <span v-html="description" />
      </template>
    </IoSectionTop>
    <div class="container-fluid l2">
      <slot />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import IoSectionTop from '../components/IoSectionTop.vue';
import IoAlerts from '../components/IoAlerts.vue';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Page',

  components: {
    IoSectionTop,
    IoAlerts,
  },

  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    center: Boolean,
  },

  computed: {
    ...mapState([
      'sidebarFixed',
    ]),
    marginLeft() {
      const sidebarWidth = this.sidebarFixed ? 280 : 80;
      return `${sidebarWidth + 3 * 16}px`;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content--header {
  position: fixed;
  z-index: 10;
  margin-top: -1px;
  left: 80px;
  right: 80px;
  transition: all .225s ease-out;
  pointer-events: none;

  @media (min-width: 1200px) {
    left: v-bind(marginLeft);
    right: calc(80px + 3rem);
  }
}
</style>
